module.exports = {"510115001":"柳城街道","510115002":"公平街道","510115003":"涌泉街道","510115004":"天府街道","510115101":"和盛镇","510115102":"永盛镇","510115103":"金马镇","510115104":"永宁镇","510115105":"万春镇","510115106":"寿安镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510115.json
// module id = 2082
// module chunks = 0